import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppletToStoreTrendingLinksContainerModel } from '../../../../../models/aggregates/applet/applet-to-store-trending-links-container.model'
import { ApiVisa, BaseApiTemplateService, Core2Config, Pagination } from "../shared";

@Injectable({
    providedIn: 'root',
})
export class AppletToStoreTrendingLinksService extends BaseApiTemplateService<AppletToStoreTrendingLinksContainerModel>{
    private sysadmin = 'sysadmin-ep'

    constructor(http: HttpClient){
        super();
        this.httpClient = http;
    }

    private setUrl(endpoint: string){
        this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + `applet-to-store-trending-links/${endpoint}`;
    }

    sysadminPost(dtoObject: AppletToStoreTrendingLinksContainerModel, apiVisa: ApiVisa){
        this.setUrl(this.sysadmin);
        return super.post(dtoObject, apiVisa);
    }

    sysadminDelete(guid: string, apiVisa: ApiVisa){
        this.setUrl(this.sysadmin);
        return super.delete(guid, apiVisa);
    }

    sysadminPut(dtoObject: AppletToStoreTrendingLinksContainerModel, apiVisa: ApiVisa){
        this.setUrl(this.sysadmin);
        return super.put(dtoObject, apiVisa);
    }

    sysadminGet(apiVisa: ApiVisa){
        this.setUrl(this.sysadmin);
        return super.get(apiVisa);
    }

    sysadminGetByGuid(guid: string, apiVisa: ApiVisa){
        this.setUrl(this.sysadmin);
        return super.getByGuid(guid, apiVisa);
    }

    sysadminGetByCriteria(pagination: Pagination, apiVisa: ApiVisa){
        this.setUrl(this.sysadmin);
        return super.getByCriteria(pagination, apiVisa);
    }
}